module.exports = __webpack_public_path__ + "static/media/banner_1.361e742f.jpg";